'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { NotFound } from '@/components/Error/NotFound';
import { SingleSignOnView } from '@/features/sso';
import { featureFlags } from '@/lib/env';
const SearchSchema = z.object({
  search: z.string().optional()
});
export const Route = createFileRoute('/_individual/individual/single-sign-on/')({
  component: SingleSignOnPage,
  validateSearch: zodValidator(SearchSchema)
});
function SingleSignOnPage() {
  const navigate = useNavigate({
    from: '/individual/single-sign-on'
  });
  const {
    search
  } = Route.useSearch();
  if (!featureFlags.check('SSO_INTEGRATION')) return <NotFound />;
  return <SingleSignOnView homeTo="/individual" search={search} onSearchChange={value => navigate({
    search: () => ({
      search: value || undefined
    })
  })} />;
}